<template>
  <div :id="`product-card-${productIndex}`" class="product-item rounded p-3 d-flex align-items-center justify-content-between">
    <div class="product-details mr-2">
      <h4 class="mb-0">
        <slot name="productName"></slot>
      </h4>
      <p class="mb-0">
        <slot name="productPrice"></slot>
      </p>
    </div>
    <div class="product-action">
      <b-button
        :id="`add-product-${uuid}`"
        class="btn-add-product shadow-none border-0 p-3"
        :disabled="!selectedOrder || !selectedBranch"
        @click="showProductViewModal">
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import _ from "lodash";

export default {
  props: ['uuid', 'productIndex'],
  computed: {
    ...mapFields("conversationalCommerce", ["viewProduct"]),
    ...mapGetters({
      products: "conversationalCommerce/products",
      selectedOrder: "conversationalCommerce/selectedOrder",
      selectedBranch: "conversationalCommerce/selectedBranch",
      errors: "conversationalCommerce/errors"
    }),
  },
  methods: {
    async showProductViewModal() {
      const product = this.products.find(product => product.uuid === this.uuid);
      const type = this.products.find(product => product.uuid === this.uuid).type;

      await this.$store.dispatch("conversationalCommerce/getProductDetails", {
        uuid: type === 'simple'
          ? product.inventories.find(item => item.branch_uuid === this.selectedBranch).uuid
          : product.uuid,
        type: type
      });
      if (_.isEmpty(this.errors) || !this.errors) this.$root.$emit("bv::show::modal", "cc-product-view-modal");
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap');

* {
  font-family: MainFontRegular, sans-serif;
}
.product-item {
  box-shadow: 0px 4px 15px 5px rgba(104, 105, 123, 0.1);
  h4 {
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
    font-size: 14px;
    color: #2F3941;
    word-break: break-all;
  }
  p {
    font-size: 14px;
    color: #68737D;
  }
  .btn-add-product {
    background: #ff8828 url('~@/assets/images/plus-icon.svg') no-repeat center / 14px;
  }
}
</style>
